module.exports = __webpack_public_path__ + "2a31b7bc32add615c0904f1a9d6b7796.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/trophy-shelf-3.png
// module id = 595
// module chunks = 0